module.exports = __webpack_public_path__ + "static/img/nz.8d51d87f.svg";